import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import CustomCursor from "./components/CustomCursor";
import PageWipe, { WIPE_IN } from "./components/PageWipe";
import ReadingProgress from "./components/ReadingProgress";
import BackToTop from "./components/BackToTop";
import TypeGuard from "./components/TypeGuard";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Landing from "./pages/Landing";
import RouteHome from "./pages/RouteHome";
import CaseStudy from "./pages/CaseStudy";
import ValiantCase from "./pages/ValiantCase";
import OricaCase from "./pages/OricaCase";
import About from "./pages/About";
import Contact from "./pages/Contact";

function Shell() {
  const location = useLocation();
  const { pathname } = location;
  const isCase = /^\/(corporate|creative)\/.+/.test(pathname);
  return (
    <div className="App min-h-screen bg-ink text-[#F9F9FB] font-grot" data-testid="app-shell">
      <PageWipe />
      <TypeGuard />
      {isCase && <ReadingProgress key={pathname} />}
      <CustomCursor />
      <Nav />
      <main>
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={pathname}
            data-testid="page-frame"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.4, delay: 0.1 } }}
            exit={{ opacity: 1, transition: { duration: WIPE_IN } }}
          >
            <Routes location={location}>
              <Route path="/" element={<Landing />} />
              <Route path="/corporate" element={<RouteHome key="corporate" route="corporate" />} />
              <Route path="/corporate/valiant-un-bid" element={<ValiantCase />} />
              <Route path="/corporate/orica" element={<OricaCase />} />
              <Route path="/corporate/:slug" element={<CaseStudy key="corporate-case" route="corporate" />} />
              <Route path="/creative" element={<RouteHome key="creative" route="creative" />} />
              <Route path="/creative/:slug" element={<CaseStudy key="creative-case" route="creative" />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Landing />} />
            </Routes>
            {isCase && <BackToTop />}
            {pathname !== "/" && <Footer />}
          </motion.div>
        </AnimatePresence>
      </main>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121418",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#F9F9FB",
            fontFamily: "'Archivo', 'Helvetica Neue', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Shell />
      </SmoothScroll>
    </BrowserRouter>
  );
}
